<template>
  <div>
    <PageTitle :route="$route" />

    <PageRowWrapper>
      <SimcardsBatch />
    </PageRowWrapper>
  </div>
</template>

<script>
import PageTitle from "@/components/layout/PageTitle";
import PageRowWrapper from "@/components/layout/PageRowWrapper";
import SimcardsBatch from "@/components/settings/stock-registers/active/SimcardsBatch";

export default {
  name: "AddSimcardsBatch",
  components: {
    PageTitle,
    PageRowWrapper,
    SimcardsBatch,
  },
};
</script>
